import { useMutation, useQuery } from "react-query";
import productService from "services/productService";
import { useToasts } from "react-toast-notifications";
import { useTranslation } from "react-i18next";
import { errorMessage } from "helpers/utils";
import { formConvertErrorMessage } from "helpers/form_helper";

export const useGroupList = (onSuccess, onError) => {
  const { t } = useTranslation(["product"]);
  const { addToast } = useToasts();

  return useQuery(["product-group-list"], () => productService.getGroupList(), {
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    enabled: true,
    retry: 1,
    onSuccess,
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.list", {
              target: t("group-product"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
    select: response => {
      const { items } = response?.data;
      return items || [];
    },
  });
};
export const useProductList = (payload, onSuccess, onError) => {
  const { enabled, params } = payload;
  return useQuery(
    ["product-list", params],
    () => productService.getProductList(params),
    {
      enabled: enabled || false,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError,
      initialData: Object({ data: {} }),
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          meta: data._meta,
        };
      },
    }
  );
};
export const useCreateProduct = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["product"]);
  const { addToast } = useToasts();

  return useMutation(productService.createProduct, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: t("product"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("product"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
export const useUpdateProduct = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["product"]);
  const { addToast } = useToasts();

  return useMutation(productService.updateProduct, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("product"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("product"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUpdateStatusProduct = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["product"]);
  const { addToast } = useToasts();

  return useMutation(productService.updateStatusProduct, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("product"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("product"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
